import { Spinner } from '@ds';
import { GenerationProcessCard } from './components';
import { AutoSchedulerInfo } from '@/api/apis/resources/schedule';

type SchedulerLoadingOverlayProps = {
  isGenerating?: boolean;
  isMutating?: boolean;
  generationInfo?: AutoSchedulerInfo | null;
  onGenerationCancel?: () => void;
};

export const SchedulerLoadingOverlay = ({
  isGenerating,
  isMutating,
  generationInfo,
  onGenerationCancel,
}: SchedulerLoadingOverlayProps) => {
  return (
    <div className="flex items-start justify-center absolute size-full left-0 top-0 backdrop-blur z-12">
      {isGenerating ? (
        <GenerationProcessCard
          generationInfo={generationInfo}
          isMutating={isMutating}
          onGenerationCancel={onGenerationCancel}
        />
      ) : (
        <Spinner size="lg" className="sticky top-[calc((100vh-20px)/2)]" />
      )}
    </div>
  );
};
